import swal from "sweetalert2";
import { pluralize } from "humanize-plus";

export async function confirmRuleWarningsOnReport(validation) {
	try {
		const result = await swal.fire({
			title: `${validation.rules.length} ${pluralize(validation.rules.length, "Warning")}`,
			input: "checkbox",
			inputValue: false, // this is the initialized value
			inputValidator: (result) => {
				return !result && "You need to confirm that the entered values are valid.";
			},
			inputPlaceholder: "I confirm these values are valid",
			html: `The following must be confirmed before proceeding.
						<br/>
						<br/>
						<ul style="text-align:left">
							${validation.rules.map(r => `<li>${r.Title}</li>`)}
						</ul>
						<br/>
						Are you sure this is correct?`,
			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Complete"
		});

		return !result.dismiss;
	}catch(err) {
		return false;
	}
}